<template>
  <div>
    <Add_customer_point/>
  </div>
</template>

<script>
import Add_customer_point from "@/components/adminArin/pos_system/customerpoint/Add_customer_point";
export default {
  name: "addcustomerpoint",
  components: {
    Add_customer_point
  }
}
</script>

<style scoped>

</style>
